import {useLocalStorage} from 'react-use';

export type markEventAsConvertedType = (id: string | undefined) => void;
export type isEventConvertedType = (id: string | undefined) => boolean;

export type useConvertedEventTrackingType = {
	markEventAsConverted: markEventAsConvertedType;
	isEventConverted: isEventConvertedType;
};
export const useConvertedEventTracking = (): useConvertedEventTrackingType => {
	const [value, setValue] = useLocalStorage('CalendarEvents.ConvertedKeys', [], {
		raw: false,
		serializer: JSON.stringify,
		deserializer: JSON.parse,
	});

	const markEventAsConverted = (id: string | undefined): void => {
		if (!id) {
			return;
		}
		const newValue = [...value];
		if (newValue.length > 100) {
			// store a maximum of 100 event ids in local storage
			newValue.shift();
		}
		setValue([...newValue, id]);
	};

	const isEventConverted = (id: string | undefined): boolean => {
		if (!id) {
			return false;
		}
		return value.includes(id);
	};

	return {markEventAsConverted, isEventConverted};
};
